define([
  /* eslint-disable */
  'js/aofl-js/0.8.0/app/app',
  'readingiq-src/js/riq-js/password-modal/1.0.0/vm-service/index-impl',
  'readingiq-src/js/riq-js/riq-user-model-service/1.0.0/index',
  'readingiq-src/js/riq-js/riq-group-model-service/1.0.0/index'
  /* eslint-enable */
], function service(app, passwordModalVmServiceImpl) {
  'use strict';

  app.registerFactory('passwordModalVmService', [
    'riqUserModelService',
    'riqGroupModelService',
    '$rootScope',
    '$state',
    passwordModalVmServiceImpl
  ]);
});
